'use strict';

import autoImporter from '@/modules/auto-importer';

const directives = autoImporter(
  require.context('@/__directives', true, /[a-zA-Z]\w+\.directive\.js$/)
);

export default directives;
